<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ titleText }}</h2>
      <button class="modal-close" type="button" (click)="onCancel()" [disabled]="submitting" aria-label="Close">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-hint">
        {{ hintText }}
      </p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label>{{ emailLabel }}</label>
          <input type="email" class="form-control" formControlName="email" placeholder="you@company.kz" />
        </div>

        <!-- ФИО и телефон — из аккаунта, если уже есть; можно поправить -->
        <div class="form-row">
          <div class="form-group">
            <label>{{ fullNameLabel }}</label>
            <input type="text" class="form-control" formControlName="fullName" autocomplete="name" [placeholder]="fullNamePlaceholderText" />
          </div>
          <div class="form-group">
            <label>{{ phoneLabel }}</label>
            <input type="tel" class="form-control" formControlName="phone" autocomplete="tel" inputmode="tel" placeholder="+7 700 000 00 00" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>{{ passwordLabel }}</label>
            <input type="password" class="form-control" formControlName="password" autocomplete="new-password" [placeholder]="passwordPlaceholderText" />
          </div>
          <div class="form-group">
            <label>{{ confirmPasswordLabel }}</label>
            <input type="password" class="form-control" formControlName="confirmPassword" autocomplete="new-password" [placeholder]="confirmPasswordPlaceholderText" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>{{ companyNameLabel }}</label>
            <input type="text" class="form-control" formControlName="companyName" [placeholder]="companyNamePlaceholderText" />
          </div>
          <div class="form-group">
            <label>{{ countryLabel }}</label>
            <app-country-select formControlName="countryId" [countries]="countries" [placeholder]="selectCountryText"></app-country-select>
          </div>
        </div>

        <div *ngIf="error" class="error-message">{{ error }}</div>

        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="submitting">{{ cancelText }}</button>
          <button type="submit" class="btn btn-primary" [disabled]="submitting">
            {{ submitting ? savingText : continueText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
